import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavLink {
  to: string;
  label: string;
}

const navLinks: NavLink[] = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/service', label: 'Our Services' },
  { to: '/product', label: 'Our Products' },
  { to: '/contact', label: 'Contact Us' },
];

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const location = useLocation();
  const [active, setActive] = useState<string>(location.pathname);

  useEffect(() => {
    setActive(location.pathname);
  }, [location.pathname]);

  const toggleMenu = (): void => {
    setIsOpen(!isOpen);
  };

  const baseClass =
    'transition-colors duration-200 px-2 py-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-400';
  const hoverClass = 'hover:text-blue-400 hover:bg-gray-700';
  const selectedClass = 'text-blue-400 bg-gray-900 font-semibold';

  return (
    <>
      <nav className="bg-gray-800 text-white shadow-md fixed top-0 w-full h-18 z-20">
        <div className="max-w-screen-xl mx-auto px-4 py-3 flex items-center justify-between">
          {/* Brand */}
          <div className="flex items-center">
            <Link to="/" className="text-3xl font-bold brand-name">APEXIUM</Link>
          </div>

          {/* Hamburger Menu Button */}
          <button
            onClick={toggleMenu}
            className="text-white md:hidden"
            aria-label="Toggle Menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6 text-lg">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`${baseClass} ${hoverClass} ${active === link.to ? selectedClass : ''}`}
                aria-current={active === link.to ? 'page' : undefined}
                tabIndex={0}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu */}
          <div
            className={`md:hidden absolute top-16 right-0 w-full bg-gray-800 transition-all duration-300 ease-in-out ${isOpen ? 'block' : 'hidden'}`}
            style={{ maxWidth: '200px' }}
          >
            <div className="flex flex-col">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`block px-4 py-2 border-b border-gray-600 ${baseClass} ${hoverClass} ${active === link.to ? selectedClass : ''}`}
                  aria-current={active === link.to ? 'page' : undefined}
                  tabIndex={0}
                  onClick={() => setIsOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
